
import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import DataView from './DataView';
import About from './Aboutus';
import Layout from './Layout';
import './assets/website.css';
import CSSlider from './CSSlider';
import NewSlider from './NewSlider';
import Contact2 from './Contact2';
import { PrivacyPolicy, TermsOfService } from './PrivacyPolicy';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<NewSlider />} />
          <Route path="about" element={<About />} />
          <Route path="solutions" element={<DataView />} />
          <Route path="services" element={<CSSlider />} />
          <Route path="contact" element={<Contact2 />} />
          <Route path="privacy" element={<PrivacyPolicy />} />
          <Route path="terms" element={<TermsOfService />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
